var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({height: _vm.height}),attrs:{"src":require("../../assets/marca.png"),"alt":"Federação Baiana, Capixaba e Mineira de Golfe"}})}
var staticRenderFns = []

export { render, staticRenderFns }